import axios from 'axios';
import type { CardWriteResponse, NarCardData } from './interfaces';
import type { CardWritePayload } from './types';

export const getCardData = () => axios.get<NarCardData | null>(`${process.env.CARD_READER_URL}/read`);

export const writeCardData = (data: { Message: Array<CardWritePayload> }) => axios
  .post<CardWriteResponse>(`${process.env.CARD_READER_URL}/write`, data);
